<template>
  <div class="filter-tabs">
    <button
      v-for="(tab, idx) in tabs"
      :key="idx"
      class="tab grey-600 text-sm"
      :class="{ tab_active: tab.slug === value }"
      @click="handleTabClick(tab.slug)"
    >
      {{ tab.title }}
    </button>
  </div>
</template>

<script>
  import get from 'lodash.get';

  export default {
    name: 'FilterTabs',
    model: {
      prop: 'value',
      event: 'change',
    },
    created() {
      this.changeQuery(this.value);
    },
    props: {
      /* {
         title: this.$t('Active'),
         slug: 'active',
       } */
      tabs: {
        type: Array,
        required: true,
      },
      value: {
        type: String,
        required: true,
      },
      query: String,
    },
    methods: {
      changeQuery(slug) {
        if (this.query && get(this.$route, `query.${this.query}`) !== slug) {
          this.$router.push({ query: { [this.query]: slug } });
        }
      },
      handleTabClick(slug) {
        this.$emit('change', slug);
        this.changeQuery(slug);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .filter-tabs {
    .tab {
      padding: 8px 12px;
      border: 1px solid $grey200;
      box-sizing: border-box;

      &:first-child {
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
      }

      &:not(:last-child) {
        border-right: none;
      }

      &_active {
        color: $primary600;
        background-color: $primary50;
        border-color: $primary200;
      }

      &:hover {
        color: $primary600;
      }
    }
  }
</style>
